/**
 * Created by draplater on 17-7-14.
 */

import * as React from 'react';
import {Panel} from 'react-bootstrap';
import * as DocumentTitle from 'react-document-title';
import {waitVersion} from "../reduxSetting";

export class ExternalPage extends React.Component<{ url: string },
    { content: string | null }> {
    constructor(props) {
        super(props);
        this.state = {content: null};
    }

    async communicate(props) {
        const req = await fetch(props.url + "?v=" + await waitVersion);
        const result = await req.text();
        const match = /<body.*?>([\s\S]*)<\/body>/.exec(result);
        if(match === null) {
            throw Error("Invalid Page.");
        } else {
            const body = match[1];
            this.setState({content: body});
        }
    }

    componentDidMount() {
        try {
            this.communicate(this.props);
        } catch(e) {
            alert(e.toString());
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({content: null});
        try {
            this.communicate(newProps);
        } catch(e) {
            alert(e.toString());
        }
    }

    render() {
        if (this.state.content === null) {
            return <div className="main-panel"> Loading...</div>;
        } else {
            return <div className="main-panel" dangerouslySetInnerHTML={{__html: this.state.content}}/>;
        }
    }
}

export function renderMainPage() {
    return <Panel>
        <ExternalPage url={"./tag/__website__/home.html"}/>
    </Panel>;
}

export function renderPublicationsPage() {
    return <DocumentTitle title="Publications - Mandarin VerbNet">
        <Panel>
            <ExternalPage url={"./tag/__website__/publications.html"}/>
        </Panel>
    </DocumentTitle>;
}

export function renderContributorsPage() {
    return <DocumentTitle title="Contributors - Mandarin VerbNet">
        <Panel>
            <ExternalPage url={"./tag/__website__/contributors.html"}/>
        </Panel>
    </DocumentTitle>;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ExternalPage.tsx